export default function getArticleAlt(article) {
    return article.title
}
